export default "__VITE_ASSET__BP10fG9q__"